import type { WorkArtistData } from '../dto/EntityRepository';
import type { UpdateWorkArtistReq } from '../dto/ReqDtoRepository';
import { ArchiveRole, MemberType, WorkContentMode } from '../enum/EnumRepository';
import type { SettingData } from '../dto/EntityRepository';

export const EMPTY_WORK_ARTIST: WorkArtistData = {
  name: '',
  nameEn: '',
  linkedMemberAui: null,
  linkedMemberHandle: null,
};

export const normalizeWorkArtist = (
  artist: WorkArtistData | null | undefined,
): WorkArtistData | null => {
  if (!artist) return null;
  return {
    name: artist.name?.trim() ?? '',
    nameEn: artist.nameEn?.trim() ?? '',
    linkedMemberAui: artist.linkedMemberAui || null,
    linkedMemberHandle: artist.linkedMemberHandle || null,
  };
};

/** 연결 작가는 AUI만 보내고 이름은 서버가 관리한다. 미연결 작가만 name을 보낸다. */
export const toUpdateWorkArtistReq = (
  artist: WorkArtistData | null | undefined,
): UpdateWorkArtistReq | null => {
  const normalized = normalizeWorkArtist(artist);
  if (normalized?.linkedMemberAui) {
    return { linkedMemberAui: normalized.linkedMemberAui };
  }
  if (!normalized?.name) return null;
  return {
    name: normalized.name,
    nameEn: normalized.nameEn,
    linkedMemberAui: normalized.linkedMemberAui,
  };
};

export const resolveWorkArtistName = (
  artist: WorkArtistData | null | undefined,
  mode: WorkContentMode = WorkContentMode.Orig,
  engVisible = true,
): string => {
  if (!artist) return '';
  if (mode === WorkContentMode.ENG && engVisible) {
    return artist.nameEn?.trim() || artist.name?.trim() || '';
  }
  return artist.name?.trim() || '';
};

export const shouldShowWorkArtist = (
  setting: Pick<SettingData, 'memberType' | 'archiveRole'> | null | undefined,
): boolean => {
  if (!setting) return false;
  if (setting.memberType === MemberType.GROUP) return true;
  return setting.archiveRole != null && setting.archiveRole !== ArchiveRole.ARTIST;
};

/** GRID(work3) 전환은 Individual + Artist 아카이브만. */
export const isIndividualArtistArchive = (
  setting: Pick<SettingData, 'memberType' | 'archiveRole'> | null | undefined,
): boolean =>
  setting?.memberType === MemberType.INDIVIDUAL
  && setting.archiveRole === ArchiveRole.ARTIST;

export const isSameWorkArtist = (
  left: WorkArtistData | null | undefined,
  right: WorkArtistData | null | undefined,
): boolean => (
  (left?.name ?? '') === (right?.name ?? '')
  && (left?.nameEn ?? '') === (right?.nameEn ?? '')
  && (left?.linkedMemberAui ?? null) === (right?.linkedMemberAui ?? null)
  && (left?.linkedMemberHandle ?? null) === (right?.linkedMemberHandle ?? null)
);
